import { jsx as u } from "react/jsx-runtime";
import { c as A } from "react/compiler-runtime";
import { createContext as a, useContext as c } from "react";
const o = a(null), m = (s) => {
  const t = A(3), {
    adapter: n,
    children: r
  } = s;
  let e;
  return t[0] !== n || t[1] !== r ? (e = /* @__PURE__ */ u(o.Provider, { value: n, children: r }), t[0] = n, t[1] = r, t[2] = e) : e = t[2], e;
};
function i() {
  const s = c(o);
  if (!s)
    throw new Error("useAiAssistant must be used inside <AiAssistantProvider>.");
  return s;
}
const p = () => i().config, x = () => i().store.actions;
function v(s, t) {
  return i().store.useSelector(s, t);
}
export {
  m as AiAssistantProvider,
  i as useAiAssistant,
  x as useAiAssistantActions,
  p as useAiAssistantConfig,
  v as useAiAssistantState
};
